export default "__VITE_ASSET__BkUDCgFQ__"